$(function () {
  $('.js-movieBt01').on('click', function(){ // 再生ボタンが押されたら
    if($(this).hasClass('is-play')){
        $('.js-movie01').get(0).pause();
    }else{
        $('.js-movie01').get(0).play();
    }
  });

  $('.js-movie01').on('playing', function(){
    $('.js-movieBt01,.js-movieTxt01,.js-movieBg01').addClass('is-play'); 
    $(this).attr('controls', ''); // ブラウザが表示する再生ボタンを非表示にするために後から属性付与
  });

  $(".js-movie01").on('pause', function(){
    $('.js-movieBt01,.js-movieTxt01,.js-movieBg01').removeClass('is-play');
    $(this).removeAttr('controls');
  });

  $('.js-movie01').on('ended', function(){ 
    $('.js-movieBt01,.js-movieTxt01,.js-movieBg01').removeClass('is-play');
    $(this).removeAttr('controls');
  });

});

$(function () {
  $('.js-movieBt02').on('click', function(){ // 再生ボタンが押されたら
      if($(this).hasClass('is-play')){
          $('.js-movie02').get(0).pause();
      }else{
          $('.js-movie02').get(0).play();
      }
  });

  $('.js-movie02').on('playing', function(){
      $('.js-movieBt02,.js-movieTxt02,.js-movieBg02').addClass('is-play'); 
      $(this).attr('controls', ''); // ブラウザが表示する再生ボタンを非表示にするために後から属性付与
  });

  $(".js-movie02").on('pause', function(){
      $('.js-movieBt02,.js-movieTxt02,.js-movieBg02').removeClass('is-play');
      $(this).removeAttr('controls');
  });

  $('.js-movie02').on('ended', function(){ 
      $('.js-movieBt02,.js-movieTxt02,.js-movieBg02').removeClass('is-play');
      $(this).removeAttr('controls');
  });

});

$(function () {
  $('.js-movieBt03').on('click', function(){ // 再生ボタンが押されたら
    if($(this).hasClass('is-play')){
        $('.js-movie03').get(0).pause();
    }else{
        $('.js-movie03').get(0).play();
    }
  });

  $('.js-movie03').on('playing', function(){
    $('.js-movieBt03,.js-movieTxt03,.js-movieBg03').addClass('is-play'); 
    $(this).attr('controls', ''); // ブラウザが表示する再生ボタンを非表示にするために後から属性付与
  });

  $(".js-movie03").on('pause', function(){
    $('.js-movieBt03,.js-movieTxt03,.js-movieBg03').removeClass('is-play');
    $(this).removeAttr('controls');
  });

  $('.js-movie03').on('ended', function(){ 
    $('.js-movieBt03,.js-movieTxt03,.js-movieBg03').removeClass('is-play');
    $(this).removeAttr('controls');
  });

  // 再生位置の取得（単位は秒）
  console.log($('.js-movie03').get(0).currentTime);
  $('.js-movie03').get(0).currentTime = 1;

});

$(function () {
  $('.js-movieBt04').on('click', function(){ // 再生ボタンが押されたら
    if($(this).hasClass('is-play')){
        $('.js-movie04').get(0).pause();
    }else{
        $('.js-movie04').get(0).play();
    }
  });

  $('.js-movie04').on('playing', function(){
    $('.js-movieBt04,.js-movieTxt04,.js-movieBg04').addClass('is-play'); 
    $(this).attr('controls', ''); // ブラウザが表示する再生ボタンを非表示にするために後から属性付与
  });

  $(".js-movie04").on('pause', function(){
    $('.js-movieBt04,.js-movieTxt04,.js-movieBg04').removeClass('is-play');
    $(this).removeAttr('controls');
  });

  $('.js-movie04').on('ended', function(){ 
    $('.js-movieBt04,.js-movieTxt04,.js-movieBg04').removeClass('is-play');
    $(this).removeAttr('controls');
  });

  // 再生位置の取得（単位は秒）
  console.log($('.js-movie04').get(0).currentTime);
  $('.js-movie04').get(0).currentTime = 1;

});
